// PWA service worker registration with auto-update + one-time reload so
// installed apps (incl. iOS Add-to-Home-Screen) always pick up new deploys.
export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        // Proactively check for updates on load.
        try { reg.update(); } catch (e) { /* noop */ }

        // If a new worker is found, ask it to activate immediately.
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              try { newWorker.postMessage('SKIP_WAITING'); } catch (e) { /* noop */ }
            }
          });
        });
      })
      .catch((err) => {
        // SW registration is best-effort; the app works without it. Surface the
        // reason in development to help diagnose PWA/caching issues.
        if (process.env.NODE_ENV !== 'production') console.warn('Service worker registration failed:', err);
      });

    // When the active worker changes (new version took control), reload once.
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}
